import React from 'react'

export default function AdminCenterAdminSettings() {
  return (
    <div>AdminCenterAdminSettings</div>
  )
}
